module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_5_1.3d5d0cc8.png";